import "core-js/modules/es6.reflect.construct.js";
import _slicedToArray from "/home/runner/work/digital-chamada/digital-chamada/frontend/chamada-frontend/node_modules/@babel/runtime-corejs2/helpers/slicedToArray.js";
import _asyncToGenerator from "/home/runner/work/digital-chamada/digital-chamada/frontend/chamada-frontend/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js";
import _classCallCheck from "/home/runner/work/digital-chamada/digital-chamada/frontend/chamada-frontend/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js";
import _createClass from "/home/runner/work/digital-chamada/digital-chamada/frontend/chamada-frontend/node_modules/@babel/runtime-corejs2/helpers/createClass.js";
import _inherits from "/home/runner/work/digital-chamada/digital-chamada/frontend/chamada-frontend/node_modules/@babel/runtime-corejs2/helpers/inherits.js";
import _possibleConstructorReturn from "/home/runner/work/digital-chamada/digital-chamada/frontend/chamada-frontend/node_modules/@babel/runtime-corejs2/helpers/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/runner/work/digital-chamada/digital-chamada/frontend/chamada-frontend/node_modules/@babel/runtime-corejs2/helpers/getPrototypeOf.js";
import _regeneratorRuntime from "/home/runner/work/digital-chamada/digital-chamada/frontend/chamada-frontend/node_modules/@babel/runtime-corejs2/regenerator/index.js";
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.regexp.split.js";
import "core-js/modules/es6.string.iterator.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.string.sub.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import Service from "./Service";
import jwtDecode from "jwt-decode";
var methodRequest = {
  POST: "post",
  PUT: "put",
  DELETE: "delete"
};
var RequestService = /*#__PURE__*/function (_Service) {
  _inherits(RequestService, _Service);
  var _super = _createSuper(RequestService);
  function RequestService() {
    _classCallCheck(this, RequestService);
    return _super.apply(this, arguments);
  }
  _createClass(RequestService, [{
    key: "getPanels",
    value: function getPanels(clienteId) {
      return this.get("paineis", this.getHeaders());
    }
  }, {
    key: "savePainelAndMedia",
    value: function savePainelAndMedia(method, clienteId, json, painelId) {
      var apiPost = "paineis";
      var apiPut = "paineis/".concat(painelId);
      if (method === methodRequest.PUT) {
        return this.put(apiPut, json, this.getHeaders().headers["Content-Type"].concat(";charset=UTF-8"));
      } else {
        return this.post(apiPost, json, this.getHeaders().headers["Content-Type"].concat(";charset=UTF-8"));
      }
    }
  }, {
    key: "freePainel",
    value: function freePainel(clienteId, canal) {
      var json = {
        channel: canal
      };
      var api = "paineis/free";
      return this.post(api, json, this.getHeaders().headers["Content-Type"].concat(";charset=UTF-8"));
    }
  }, {
    key: "speak",
    value: function speak(voice, text) {
      var json = {
        text: text
      };
      var api = "speak/".concat(voice);
      return this.post(api, json, this.getHeaders().headers["Content-Type"].concat(";charset=UTF-8"));
    }
  }, {
    key: "uploadVideos",
    value: function () {
      var _uploadVideos = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(clienteId, file) {
        var response;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.get("videos/upload-key/file/".concat(file.name), this.getHeaders());
            case 2:
              response = _context.sent;
              return _context.abrupt("return", new Promise(function (resolve, reject) {
                var xhr = new XMLHttpRequest();
                xhr.open("PUT", response.data, true);
                xhr.setRequestHeader("Content-Type", "video/mp4");
                xhr.onload = function () {
                  if (xhr.status === 200) {
                    resolve("Gravado com sucesso");
                  } else {
                    reject("Erro ao gravar");
                  }
                };
                xhr.onerror = function () {
                  reject("Erro ao gravar");
                };
                xhr.send(file);
              }));
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function uploadVideos(_x, _x2) {
        return _uploadVideos.apply(this, arguments);
      }
      return uploadVideos;
    }()
  }, {
    key: "uploadLogo",
    value: function () {
      var _uploadLogo = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(clienteId, file) {
        var response;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this.get("logos/upload-key", this.getHeaders());
            case 2:
              response = _context2.sent;
              return _context2.abrupt("return", new Promise(function (resolve, reject) {
                var xhr = new XMLHttpRequest();
                xhr.open("PUT", response.data, true);
                xhr.setRequestHeader("Content-Type", "image/png");
                xhr.onload = function () {
                  if (xhr.status === 200) {
                    resolve("Gravado com sucesso");
                  } else {
                    reject("Erro ao gravar");
                  }
                };
                xhr.onerror = function () {
                  reject("Erro ao gravar");
                };
                xhr.send(file);
              }));
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function uploadLogo(_x3, _x4) {
        return _uploadLogo.apply(this, arguments);
      }
      return uploadLogo;
    }()
  }, {
    key: "findPanelByChannel",
    value: function findPanelByChannel(clienteId, channel) {
      var api = "paineis/findByPanelChannel/".concat(channel);
      return this.get(api, this.getHeaders());
    }
  }, {
    key: "shouldCollectFrontendLogs",
    value: function shouldCollectFrontendLogs(clienteId) {
      var api = "clientes/".concat(clienteId, "/shouldCollectFrontendLogs");
      return this.get(api, this.getHeaders());
    }
  }, {
    key: "getPathBase",
    value: function getPathBase() {
      return this.getBaseUrl();
    }
  }, {
    key: "getLogo",
    value: function getLogo(clienteId) {
      var api = "logos/logo.png";
      return this.get(api, this.getHeaders());
    }
  }, {
    key: "addPainelOnline",
    value: function addPainelOnline(sessionId, channel) {
      var api = "paineis-online/".concat(sessionId, "/").concat(channel);
      return this.post(api, this.getHeaders());
    }
  }, {
    key: "deletePainelOnline",
    value: function deletePainelOnline(sessionId) {
      var api = "paineis-online/".concat(sessionId);
      return this.delete(api, this.getHeaders());
    }

    //DEPRECATED
  }, {
    key: "getPanelByChannel",
    value: function getPanelByChannel() {
      var context = window.location.pathname.split("/");
      if (context[1] !== "") {
        return this.get(context[1] + "/painel/all", this.getHeaders());
      } else {
        return this.get("painel/all", this.getHeaders());
      }
    }
  }, {
    key: "getMidiaConfig",
    value: function getMidiaConfig(painelId) {
      var api = "midia/".concat(painelId, "/getInfo");
      return this.get(api, this.getHeaders());
    }
  }, {
    key: "getCallMessages",
    value: function getCallMessages(clientId) {
      var api = "callMessages/".concat(clientId);
      return this.get(api, this.getHeaders());
    }
  }, {
    key: "saveMessage",
    value: function saveMessage(payload) {
      return this.post("callMessages", payload, this.getHeaders());
    }
  }, {
    key: "delMessage",
    value: function delMessage(id) {
      return this.delete("callMessages/".concat(id), this.getHeaders());
    }
  }, {
    key: "getAllPlaces",
    value: function getAllPlaces(clientId) {
      var api = "placeNames/".concat(clientId);
      return this.get(api, this.getHeaders());
    }
  }, {
    key: "savePlace",
    value: function savePlace(payload) {
      return this.post("placeNames", payload, this.getHeaders());
    }
  }, {
    key: "deletePlace",
    value: function deletePlace(id) {
      return this.delete("placeNames/".concat(id), this.getHeaders());
    }
  }, {
    key: "saveConfigStyle",
    value: function saveConfigStyle(payload, clientId) {
      var api = "configStylesPainel";
      return this.post("".concat(api, "/").concat(clientId), payload, this.getHeaders());
    }
  }, {
    key: "saveMidiaConfig",
    value: function saveMidiaConfig(method, painelId, json) {
      var apiPut = "/midia/".concat(json.id, "/").concat(painelId);
      var apiPost = "/midia/".concat(painelId, "/");
      if (method === methodRequest.PUT) {
        return this.put(apiPut, json, this.getHeaders().headers["Content-Type"].concat(";charset=UTF-8"));
      } else {
        return this.post(apiPost, json, this.getHeaders().headers["Content-Type"].concat(";charset=UTF-8"));
      }
    }

    //DEPRECATED
  }, {
    key: "savePanel",
    value: function savePanel(json) {
      var context = window.location.pathname.split("/");
      if (context[1] !== "") {
        return this.post(context[1] + "/painel/create", json, this.getHeaders().headers["Content-Type"].concat(";charset=UTF-8"));
      } else {
        return this.post("painel/create", json, this.getHeaders().headers["Content-Type"].concat(";charset=UTF-8"));
      }
    }
  }, {
    key: "deletePainel",
    value: function deletePainel(clienteId, painelId) {
      return this.delete("paineis/".concat(painelId), this.getHeaders());
    }

    //DEPRECATED
  }, {
    key: "getMidiaInfo",
    value: function getMidiaInfo(clienteId) {
      var context = window.location.pathname.split("/");
      if (context[1] != "") {
        return this.get(context[1] + "/midia/getInfoByClienteId", this.getHeaders());
      } else {
        return this.get("/midia/".concat(clienteId, "/getInfoByClienteId"), this.getHeaders());
      }
    }
  }, {
    key: "getVideos",
    value: function getVideos(clienteId) {
      var api = "videos";
      return this.get(api, this.getHeaders());
    }
  }, {
    key: "deleteVideo",
    value: function deleteVideo(name, clienteId) {
      var api = "/videos/".concat(name, "/");
      return this.delete(api, this.getHeaders());
    }
  }, {
    key: "loginClient",
    value: function loginClient(clientId, clientPassword) {
      return this.post("/login", {
        id: clientId,
        pin: clientPassword
      }, this.getHeaders());
    }
  }, {
    key: "saveYoutube",
    value: function saveYoutube(data) {
      var endpoint = "videos/youtube";
      return this.post(endpoint, data, this.getHeaders());
    }
  }, {
    key: "getVideosYoutube",
    value: function getVideosYoutube() {
      var endpoint = "videos/youtube";
      return this.get(endpoint, this.getHeaders());
    }
  }, {
    key: "deleteVideoYoutube",
    value: function deleteVideoYoutube(code) {
      var api = "videos/youtube/".concat(code);
      return this.delete(api, this.getHeaders());
    }
  }, {
    key: "getAllVideos",
    value: function () {
      var _getAllVideos = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(clientId) {
        var videos, _yield$Promise$all, _yield$Promise$all2, youtubeResponse, localResponse, youtubeVideos, localVideos;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              videos = [];
              _context3.prev = 1;
              _context3.next = 4;
              return Promise.all([this.getVideosYoutube(), this.getVideos(clientId)]);
            case 4:
              _yield$Promise$all = _context3.sent;
              _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
              youtubeResponse = _yield$Promise$all2[0];
              localResponse = _yield$Promise$all2[1];
              youtubeVideos = youtubeResponse.data.map(function (video) {
                video.origin = 'youtube';
                return video;
              });
              localVideos = localResponse.data.map(function (video) {
                video.origin = 'local';
                return video;
              });
              return _context3.abrupt("return", videos.concat(youtubeVideos, localVideos));
            case 13:
              _context3.prev = 13;
              _context3.t0 = _context3["catch"](1);
              console.error('Erro ao buscar vídeos:', _context3.t0);
              return _context3.abrupt("return", []);
            case 17:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[1, 13]]);
      }));
      function getAllVideos(_x5) {
        return _getAllVideos.apply(this, arguments);
      }
      return getAllVideos;
    }()
  }, {
    key: "getHeaders",
    value: function getHeaders() {
      return {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("painel-web-auth-token")
        }
      };
    }
  }, {
    key: "revalidarToken",
    value: function revalidarToken(clienteId) {
      var decoded_jwt = jwtDecode(localStorage.getItem("painel-web-auth-token"));
      return decoded_jwt.sub == clienteId;
    }
  }]);
  return RequestService;
}(Service);
export default RequestService;
export { methodRequest };